import React from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    CircularProgress
} from '@mui/material';
import {
    Visibility as VisibilityIcon,
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import './PolicyCard.css';

const PolicyCard = ({ doc, index, isOpened, isLoading, onView }) => {
    return (
        <Card className={`policy-card-root ${isOpened ? 'is-opened' : ''}`}>
            <CardContent className="policy-card-content">
                <Box className="policy-card-header">
                    <Box className="policy-card-index">
                        {index + 1}
                    </Box>
                    {isOpened && (
                        <CheckCircleIcon className="policy-card-check-icon" />
                    )}
                </Box>

                <Typography variant="body1" className="policy-card-title">
                    {doc.document_name}
                </Typography>

                <Button
                    variant="outlined"
                    startIcon={
                        isLoading ? (
                            <CircularProgress size={14} />
                        ) : (
                            <VisibilityIcon className="policy-card-view-icon" />
                        )
                    }
                    onClick={() => onView(doc.document_id)}
                    disabled={isLoading}
                    className="policy-card-button"
                >
                    {isLoading ? 'Loading...' : 'View'}
                </Button>
            </CardContent>
        </Card>
    );
};

export default PolicyCard;
